import { ArticleHeading3, ArticleHeading5, Responsive, TDeviceType } from '@cian/ui-kit';
import * as style from './SolveProblems.css';
import { clsx } from 'clsx';
import { Title } from '../Title';

interface ISolveProblemsProps {
  points: JSX.Element;
  device: TDeviceType;
  accordion: JSX.Element;
}

export const SolveProblems: React.FC<ISolveProblemsProps> = ({ points, device, accordion }) => {
  const ItemSubTitle = device === 'phone' ? ArticleHeading5 : ArticleHeading3;

  return (
    <div
      id="advantages"
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['banner-container']}>
        <div className={style['title']}>
          <Title>Решим проблемы — упростим и ускорим процесс сдачи</Title>
        </div>
        <div className={style['banner-items']}>
          <div className={style['banner-item']}>
            <div className={style['item-title']}>Если сдаёте впервые</div>
            <div>
              <ItemSubTitle fontWeight="400">
                И ещё не знаете, как составить правильный договор, добиться максимальной выгоды и найти надёжных
                арендаторов.
              </ItemSubTitle>
            </div>
          </div>
          <div className={style['banner-item']}>
            <div className={style['item-title']}>Если сдаёте повторно</div>
            <div>
              <ItemSubTitle fontWeight="400">
                И уже устали терять деньги из-за неожиданно съехавших жильцов, не хотите тратить время на пустые показы.
              </ItemSubTitle>
            </div>
          </div>
        </div>
      </div>
      <Responsive desktop>{points}</Responsive>
      <Responsive tablet phone>
        {accordion}
      </Responsive>
    </div>
  );
};
